import type { StreamSettingsResponseStream } from "~/stream/StreamSettings";

import type { AutomationsConfigurationsData$data as AutomationsConfigurationsData } from "~/__generated__/AutomationsConfigurationsData.graphql";
import type { StreamSettingsModalQuery } from "~/__generated__/StreamSettingsModalQuery.graphql";

export type StreamSettingsViewer = StreamSettingsModalQuery["response"]["viewer"];

export type ConfigurationType = NonNullable<NonNullable<StreamSettingsResponseStream>["automationConfigurations"]>[0];

export type AutomationType = StreamSettingsModalQuery["response"]["automations"][0];

export type TaskType = AutomationsConfigurationsData["tasks"][0];

export type UserType = NonNullable<NonNullable<StreamSettingsResponseStream>["notestreamusers"]>[0]["user"];

export const NOTIFICATION_TARGET_VALUES = ["ORGANIZER", "ALL"] as const;
export type NotificationTargetValueType = (typeof NOTIFICATION_TARGET_VALUES)[number];
export const TARGET_TEXT_MAP = {
	ORGANIZER: "Meeting Organizer",
	ALL: "All participants",
} as const;

export const NOTIFICATION_PATH_VALUES = ["EMAIL", "SLACK", "MSTEAMS", "ZOOM"] as const;
export type NotificationPathValueType = (typeof NOTIFICATION_PATH_VALUES)[number];
export const PATH_TEXT_MAP = {
	EMAIL: "Email",
	SLACK: "Slack",
	MSTEAMS: "MS Teams",
	ZOOM: "Zoom",
} as const;

export enum AUTOMATION_CODE {
	TIME_SAVER = "time-saver",
	MEETING_REMINDER = "pre-meeting-reminder",
	MEETING_RECAP = "post-meeting-recap",
	PROMPT_NOTIFICATION = "prompt-notification",
	SCHEDULING_MEETING_ASSISTANT = "scheduling-meeting-assistant",
	AUTO_SHARE_TO_CHANNELS = "auto-share-to-channels",
}
